import React from 'react';
import styled from 'styled-components';
import * as Three from 'three';
import { CAPanelBody, CAPanelH1, CAPanelH2 } from './ca-panel';
import { Row, Col } from 'antd';
import { CADivider } from './ca-object-details';
import { CAVariableInput } from './ca-variable-input';
import { CASmartToggle } from './ca-smart-toggle';
import StateService from '../../services/state.service';
import EditorService from '../../services/editor.service';
import { CAModalBorderRadius } from './shared';

export const ComboRow = styled(Col)`
  background-color: #ffffff;
  border-radius: ${CAModalBorderRadius};
  overflow: hidden;
  margin-bottom: 8px;
`;

const CAFormMode = {
  login: 0,
  signUp: 1
};

export class CALogin extends React.Component {
  state = {
    mode: CAFormMode.login,
    login: '',
    password: '',
    pending: false,
    error: false,
    requested: false
  };

  renderLoginForm() {
    const { error } = this.state;
    const { onUpdated } = this.props;

    return (
      <>
        {
          error && (
            <Col span={24}>
              <Row style={{ marginBottom: 8, textAlign: 'center' }}>
                <Col span={24}>
                  <CAPanelH2>
                    Incorrect credentials.
                  </CAPanelH2>
                </Col>
              </Row>
            </Col>
          )
        }
        <CAVariableInput
          inputType="text"
          span={24}
          value={this.state.login}
          inputProps={{
            placeholder: 'E-mail',
            tabindex: 1
          }}
          onChange={(value) => {
            this.state.login = value;
            this.forceUpdate();
          }}
          wrapperProps={{
            style: {
              padding: 8,
              minHeight: 0,
              marginBottom: 8
            }
          }}
        />
        <ComboRow span={24}>
          <Row>
            <CAVariableInput
              inputType="password"
              span={14}
              value={this.state.password}
              inputProps={{
                placeholder: 'Password',
                tabindex: 2
              }}
              onChange={(value) => {
                this.state.password = value;
                this.forceUpdate();
              }}
              wrapperProps={{
                style: {
                  padding: 8,
                  minHeight: 0,
                  borderRadius: 0
                }
              }}
            />
            <CAVariableInput
              inputType="button"
              span={10}
              onClick={(value) => {
                if (this.state.pending || !(this.state.login && this.state.password)) {
                  return;
                }

                this.state.pending = true;
                this.state.error = false;

                StateService.clearAll();

                EditorService.login(this.state.login, this.state.password)
                .then(async () => {
                  this.state.pending = false;
                  this.state.error = false;

                  await StateService.fetchProject();

                  this.forceUpdate();
                  onUpdated();
                })
                .catch(() => {
                  this.state.pending = false;
                  this.state.error = true;
                  this.forceUpdate();
                });

                this.forceUpdate();
              }}
              inputProps={{
                style: {
                  textAlign: 'center'
                },
                danger: this.state.login && this.state.password,
                pending: this.state.pending,
                disabled: this.state.pending,
                tabindex: 3
              }}
            >
              Log In
            </CAVariableInput>
          </Row>
        </ComboRow>
        <Col span={24}>
          <Row style={{ marginBottom: 8, textAlign: 'center' }}>
            <Col span={24}>
              <CAPanelH2>
                Or
              </CAPanelH2>
            </Col>
          </Row>
        </Col>
        <a href="https://access.wtlstudio.com/" target="_blank">
          <CAVariableInput
            inputType="button"
            span={24}
            onClick={(value) => {}}
            inputProps={{
              style: {
                textAlign: 'center'
              },
              tabindex: 4
            }}
          >
            Sign Up
          </CAVariableInput>
        </a>
      </>
    );
  }

  renderSignUpForm() {
    const { onUpdated } = this.props;

    return (
      <>
        {
          this.state.requested ? (
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <CAPanelH2>
                  Request sent!
                </CAPanelH2>
              </Col>
            </Row>
          ) : (
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <CAPanelH2>
                  Request early access to Common.
                </CAPanelH2>
              </Col>
            </Row>
          )
        }
        <ComboRow span={24}>
          <Row>
            <CAVariableInput
              inputType="text"
              span={14}
              value={this.state.requestAccess}
              inputProps={{
                placeholder: 'E-mail',
                tabindex: 1
              }}
              onChange={(value) => {
                this.state.requestAccess = value;
                this.forceUpdate();
              }}
              wrapperProps={{
                style: {
                  padding: 8,
                  minHeight: 0,
                  borderRadius: 0
                }
              }}
            />
            <CAVariableInput
              inputType="button"
              span={10}
              onClick={(value) => {
                if (this.state.pending || this.state.requested || !this.state.requestAccess) {
                  return;
                }

                this.state.pending = true;
                this.state.requested = false;

                setTimeout(() => {
                  this.state.pending = false;
                  this.state.requested = true;
                  this.forceUpdate();
                  onUpdated();
                }, 1000);

                this.forceUpdate();
              }}
              inputProps={{
                style: {
                  textAlign: 'center'
                },
                danger: this.state.requestAccess,
                pending: this.state.pending,
                disabled: this.state.pending,
                tabindex: 2,
              }}
            >
              Send
            </CAVariableInput>
          </Row>
        </ComboRow>
        <Col span={24}>
          <Row style={{ marginBottom: 8, textAlign: 'center' }}>
            <Col span={24}>
              <CAPanelH2>
                Or
              </CAPanelH2>
            </Col>
          </Row>
        </Col>
        <CAVariableInput
          inputType="button"
          span={24}
          onClick={(value) => {
            if (this.state.pending) {
              return;
            }

            this.state.mode = CAFormMode.login;
            this.forceUpdate();
          }}
          inputProps={{
            style: {
              textAlign: 'center'
            },
            tabindex: 4
          }}
        >
          Login
        </CAVariableInput>
      </>
    );
  }

  render() {
    const { mode } = this.state;

    return (
      <CAPanelBody margin="20px 25px" style={{ overflow: 'visible' }}>
        <Row>
          <Col span={12}>
            <CAPanelH1>
              Login
            </CAPanelH1>
          </Col>
        </Row>
        <Row style={{ marginTop: 15 }}>
          {mode === CAFormMode.login && this.renderLoginForm()}
          {mode === CAFormMode.signUp && this.renderSignUpForm()}
        </Row>
      </CAPanelBody>
    );
  }
}
